import { createBrowserRouter, Navigate } from "react-router-dom";
import { ROUTES } from "@/app/routes";
import { AdminLayout } from "@/components/layout/AdminLayout";
import { MaintenanceGate } from "@/components/layout/MaintenanceGate";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { ProtectedAdminRoute } from "@/features/auth/ProtectedAdminRoute";
import { AdminDashboardPage } from "@/pages/admin/AdminDashboardPage";
import { AdminLoginPage } from "@/pages/admin/AdminLoginPage";
import { AboutPageAdmin } from "@/pages/admin/about/AboutPageAdmin";
import { CommissionSettingsPage } from "@/pages/admin/commission-settings/CommissionSettingsPage";
import { ContactSubmissionsPage } from "@/pages/admin/contact-submissions/ContactSubmissionsPage";
import { PartnersPage as AdminPartnersPage } from "@/pages/admin/partners/PartnersPage";
import { PortfolioItemsPage } from "@/pages/admin/portfolio-items/PortfolioItemsPage";
import { PortfolioCategoriesPage } from "@/pages/admin/portfolio-categories/PortfolioCategoriesPage";
import { ReferencesPage as AdminReferencesPage } from "@/pages/admin/references/ReferencesPage";
import { LegalPagesPage } from "@/pages/admin/legal-pages/LegalPagesPage";
import { MediaPage } from "@/pages/admin/media/MediaPage";
import { SiteSettingsPage } from "@/pages/admin/site-settings/SiteSettingsPage";
import { SocialLinksPage } from "@/pages/admin/social-links/SocialLinksPage";
import { ProfilePage } from "@/pages/admin/users/ProfilePage";
import { UsersPage } from "@/pages/admin/users/UsersPage";
import { AboutPage } from "@/pages/public/AboutPage";
import { CommissionsPage } from "@/pages/public/CommissionsPage";
import { ContactPage } from "@/pages/public/ContactPage";
import { LegalPage } from "@/pages/public/LegalPage";
import { PartnersPage } from "@/pages/public/partners/PartnersPage";
import { PortfolioDetailPage } from "@/pages/public/portfolio/PortfolioDetailPage";
import { PortfolioPage } from "@/pages/public/portfolio/PortfolioPage";
import { ReferencesPage } from "@/pages/public/references/ReferencesPage";
import { SocialsPage } from "@/pages/public/SocialsPage";
import { HomePage } from "@/pages/home/HomePage";
import { NotFound } from "@/pages/NotFound";

export const router = createBrowserRouter([
  {
    path: ROUTES.home,
    element: (
      <MaintenanceGate>
        <HomePage />
      </MaintenanceGate>
    ),
  },
  {
    path: ROUTES.home,
    element: (
      <MaintenanceGate>
        <PublicLayout />
      </MaintenanceGate>
    ),
    children: [
      { path: "about", element: <AboutPage /> },
      { path: "commissions", element: <CommissionsPage /> },
      { path: "portfolio", element: <PortfolioPage /> },
      { path: "portfolio/:slug", element: <PortfolioDetailPage /> },
      { path: "partners", element: <PartnersPage /> },
      { path: "references", element: <ReferencesPage /> },
      { path: "contact", element: <ContactPage /> },
      { path: "socials", element: <SocialsPage /> },
      { path: "terms", element: <LegalPage slug="terms" /> },
      { path: "privacy", element: <LegalPage slug="privacy" /> },
      { path: "terms-of-use", element: <LegalPage slug="terms-of-use" /> },
      { path: "disclaimer", element: <LegalPage slug="disclaimer" /> },
    ],
  },
  {
    path: ROUTES.admin.login,
    element: <AdminLoginPage />,
  },
  {
    path: ROUTES.admin.root,
    element: (
      <ProtectedAdminRoute>
        <AdminLayout />
      </ProtectedAdminRoute>
    ),
    children: [
      { index: true, element: <AdminDashboardPage /> },
      { path: "about", element: <AboutPageAdmin /> },
      { path: "portfolio", element: <PortfolioItemsPage /> },
      { path: "portfolio/categories", element: <PortfolioCategoriesPage /> },
      { path: "partners", element: <AdminPartnersPage /> },
      { path: "references", element: <AdminReferencesPage /> },
      { path: "commissions", element: <CommissionSettingsPage /> },
      {
        path: "contact-submissions",
        element: (
          <ProtectedAdminRoute minimumRole="ADMIN">
            <ContactSubmissionsPage />
          </ProtectedAdminRoute>
        ),
      },
      { path: "legal", element: <LegalPagesPage /> },
      { path: "media", element: <MediaPage /> },
      { path: "socials", element: <SocialLinksPage /> },
      {
        path: "settings",
        element: (
          <ProtectedAdminRoute minimumRole="ADMIN">
            <SiteSettingsPage />
          </ProtectedAdminRoute>
        ),
      },
      {
        path: "users",
        element: (
          <ProtectedAdminRoute minimumRole="ADMIN">
            <UsersPage />
          </ProtectedAdminRoute>
        ),
      },
      { path: "profile", element: <ProfilePage /> },
      { path: "*", element: <Navigate to={ROUTES.admin.root} replace /> },
    ],
  },
  { path: "*", element: <NotFound /> },
]);
